import FantasyPlayersMetaModel from "./Meta/FantasyPlayersMetaModel";
import PlayerPointsModel from "./PlayerPointsModel";

export default class FantasyPlayersPointsModel {
  public meta: FantasyPlayersMetaModel = new FantasyPlayersMetaModel();
  public data: PlayerPointsModel[] = [];
}
